import React from 'react';
import { motion } from 'framer-motion';
import { animationParams, animationVariants } from 'fragments';
import { Svg } from 'assets';
import { clearinghouseFeatures, integrations } from './constants';

export const IntegrationsSection = ({
    classNameWrapper,
    themeConfig = {},
    label = 'INTEGRATIONS',
    title = 'Integrations That Power Your Practice',
    subtitle = 'TherapyLake connects with the tools ABA practices rely on to streamline scheduling, billing, communication, telehealth, and clinical workflows.',
}) => {
    const {
        sectionBg = 'linear-gradient(180deg, rgba(245, 243, 255, 0.50) -233.52%, #FFF 100%)',
        accentColor = '#6941C6',
        badgeStyles = {
            color: '#7F56D9',
            backgroundColor: '#F4EBFF',
        },
        clearinghouseBg = 'linear-gradient(120deg, #FAF5FF -30.95%, #FCF8FF -24.49%, #FFFEFF 51.27%, #FFF 87.22%, #FFF 118.61%)',
        clearinghouseBorder = '1px solid #E9D7FE',
        tagBorder = '1px solid #F9F5FF',
    } = themeConfig;

    return (
        <section
            className={`landing-integrations ${classNameWrapper ? classNameWrapper : ''}`}
            style={{ background: sectionBg }}
        >
            <div className="container">
                <div className="landing-integrations__header">
                    <motion.p
                        className="landing-integrations__label"
                        style={{ color: accentColor }}
                        {...animationParams}
                        variants={animationVariants.titleVariantMobile}
                    >
                        {label}
                    </motion.p>
                    <div style={{ overflow: 'hidden' }}>
                        <motion.h2
                            className="landing-integrations__title"
                            {...animationParams}
                            variants={animationVariants.titleVariant}
                        >
                            {title}
                        </motion.h2>
                    </div>
                    <div style={{ overflow: 'hidden' }}>
                        <motion.p
                            className="landing-integrations__subtitle"
                            {...animationParams}
                            variants={animationVariants.titleVariant}
                        >
                            {subtitle}
                        </motion.p>
                    </div>
                </div>

                <motion.div
                    className="landing-integrations__cards"
                >
                    {integrations?.map(({ Logo, ...item }, index) => (
                        <motion.div
                            key={index}
                            className="landing-integrations__card"
                            {...animationParams}
                            variants={animationVariants.cardsVariant}
                        >
                            <div className="landing-integrations__card-content">
                                <div className="landing-integrations__card-head">
                                    <div className="landing-integrations__card-logo">
                                        {Logo}
                                    </div>

                                    <div className="full-width">
                                        <h3 className="landing-integrations__card-name">
                                            {item.name}
                                        </h3>

                                        <p
                                            className="landing-integrations__card-category"
                                            style={{
                                                color: accentColor,
                                            }}
                                        >
                                            {item.category}
                                        </p>
                                    </div>
                                </div>
                                <p className="landing-integrations__card-desc">{item.description}</p>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div
                    className="landing-integrations__clearinghouse"
                    style={{
                        background: clearinghouseBg,
                        border: clearinghouseBorder,
                    }}
                    {...animationParams}
                    variants={animationVariants.cardsVariant}
                >
                    <div className="landing-integrations__clearinghouse-info">
                        <p className="landing-integrations__clearinghouse-badge" style={badgeStyles}>
                            Built-In
                        </p>
                        <h3 className="landing-integrations__clearinghouse-title">TherapyLake Clearinghouse</h3>
                        <p className="landing-integrations__clearinghouse-desc">
                            A fully integrated clearinghouse built directly into TherapyLake ― no third-party setup
                            required.
                            Streamline your entire revenue cycle from one unified platform.
                        </p>
                    </div>
                    <div className="landing-integrations__clearinghouse-tags">
                        {clearinghouseFeatures.map((feature, idx) => (
                            <span
                                key={idx}
                                className="landing-integrations__clearinghouse-tag"
                                style={{ border: tagBorder }}
                            >
                                <Svg.Check2Svg />
                                {feature}
                            </span>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
